import { Component } from '@angular/core';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { AppInfo } from '../../../../global/environment';

@Component({
  selector: 'app-support-needs-banner',
  imports: [ButtonComponent],
  templateUrl: './support-needs-banner.component.html',
  styleUrl: './support-needs-banner.component.scss',
})
export class SupportNeedsBannerComponent {
  myPreferencesPageLink = `${AppInfo.Environment.myAccountURL}/my-account/my-preferences`;
}
